var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_5704)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7875 6.26L16.155 8.8175C16.3725 8.9825 16.5 9.23 16.5 9.5C16.5 9.77 16.3725 10.0175 16.155 10.1825L12.7875 12.74C10.5675 14.42 7.425 14.42 5.205 12.74L1.845 10.1825C1.6275 10.0175 1.5 9.77 1.5 9.5C1.5 9.23 1.6275 8.9825 1.845 8.8175L5.2125 6.26C7.425 4.58 10.575 4.58 12.7875 6.26ZM7.1475 9.5C7.1475 10.475 7.98 11.2625 9 11.2625C10.02 11.2625 10.8525 10.475 10.8525 9.5C10.8525 8.525 10.02 7.7375 9 7.7375C7.98 7.7375 7.1475 8.525 7.1475 9.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_5704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 9,
    fill: "white",
    transform: "translate(1.5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1);
export default __webpack_public_path__ + "static/media/eye1.1b6feefd758d3f2649fe7f4c5029c018.svg";
export { ForwardRef as ReactComponent };